<template>
    <div class="root">
        <div class="container">
            <el-form class="login_form" :model="loginData">
                <div class="login_main">
                    <div class="item_container logo_container">
                        <div class="logo_wrap">
                            <img src="@/assets/images/logo.png" class="company_logo">
                        </div>
                    </div>
                    <div class="item_container">
                        <div class="platform_name">同擎体育管理系统</div>
                    </div>
                    <div class="item_container">
                        <el-input placeholder="请输入账号" v-model="loginData.userName" prefix-icon="User" style="width: 100%;" />
                    </div>
                    <div class="item_container">
                        <el-input v-model="loginData.password" type="password" placeholder="请输入密码" prefix-icon="Lock" style="width: 100%;" />
                    </div>
                    <div class="item_container captcha_wrap">
                        <el-input v-model="loginData.captchaCode" @keypress.enter="onEnterPress" placeholder="请输入验证码" maxlength="4" style="width: calc(100% - 120px);" />
                        <img ref="captchaRef" class="captcha_img" @click="changeCaptcha">
                    </div>
                    <el-button class="login_button" type="primary" @click="loginSubmit">登 录</el-button>
                </div>
            </el-form>
        </div>
        <footer class="beian-bar">
            <span class="beian-item">© 2026 北京同擎体育文化有限公司</span>
            <span class="beian-divider">|</span>
            <el-link href="https://beian.miit.gov.cn/" target="_blank" :underline="false" class="beian-link">
                京ICP备2026051853号-1
            </el-link>
            <span class="beian-divider">|</span>
            <span class="beian-gongan">
                <img src="@/assets/images/wangan.png" alt="" class="gongan-icon">
                <el-link href="https://www.beian.gov.cn/portal/register/system/info?recordcode=11011402057079" target="_blank" :underline="false" class="beian-link">
                    京公网安备11011402057079号
                </el-link>
            </span>
        </footer>
    </div>
</template>

<script>
export default {
    data () {
        return {
            loginData: {
                userName: '',
                password: '',
                captchaCode: '',
                captchaFlag: ''
            }
        }
    },
    mounted () {
        sessionStorage.setItem('token', '')
        this.changeCaptcha()
    },
    methods: {
        onEnterPress (e) {
            if (e.keyCode === 13) {
                this.loginSubmit()
            }
        },
        loginSubmit () {
            if (this.loginData.userName === '') {
                this.$myMessage.errMsg('请输入账号')
                return
            }
            if (this.loginData.password === '') {
                this.$myMessage.errMsg('请输入密码')
                return
            }
            if (this.loginData.captchaCode === '') {
                this.$myMessage.errMsg('请输入验证码')
                return
            }
            this.loginData.userName = this.loginData.userName.trim()
            const loginDataTemp = JSON.parse(JSON.stringify(this.loginData))
            loginDataTemp.password = this.$md5(loginDataTemp.userName + loginDataTemp.password)
            loginDataTemp.browser = navigator.userAgent
            this.$request.post(this.$apiUrl.loginIn, loginDataTemp)
                .then((rs = {}) => {
                    if (rs.code !== 0) {
                        this.loginData.captchaCode = ''
                        this.changeCaptcha()
                    } else {
                        sessionStorage.setItem('token', rs.data.token)
                        sessionStorage.setItem('userInfo', JSON.stringify(rs.data.userInfo))
                        sessionStorage.setItem('userMenuList', JSON.stringify(rs.data.userMenuList))
                        if (rs.data.userMenuList.length === 0) {
                            this.loginData.captchaCode = ''
                            this.changeCaptcha()
                            this.$myMessage.errMsg('暂未分配权限，请先联系管理赋予权限后登录。')
                            return
                        }
                        this.$router.push('/' + rs.data.pageUrl)
                    }
                })
        },
        changeCaptcha () {
            this.loginData.captchaFlag = new Date().getTime().toString() + (Math.floor(Math.random() * (999999 - 100000 + 1)) + 100000).toString()
            this.$refs.captchaRef.setAttribute('src', this.$apiDomain + 'captcha-image?captcha_flag=' + this.loginData.captchaFlag)
        }
    }
}
</script>

<style lang="less" scoped>
.root {
    height: 100%;
    margin: 0;
    padding: 0;
}
.container {
    height: 100vh;
    width: 100vw;
    display: flex;
    justify-content: center;
    align-items: center;
    background: url("../assets/images/login_background.png");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
}
.login_form {
    width: 380px;
    padding: 40px 40px 30px !important;
    font-size: 14px !important;
    border: 1px solid rgba(255, 255, 255, 0.3) !important;
    -webkit-backdrop-filter: blur(16px) saturate(180%) !important;
    backdrop-filter: blur(16px) saturate(180%) !important;
    background: rgba(255, 255, 255, 0.88) !important;
    border-radius: 12px !important;
    box-shadow: 0 8px 32px rgba(0, 0, 0, 0.1) !important;
}
.logo_container {
    text-align: center;
    margin-bottom: 10px !important;
}
.logo_wrap {
    display: inline-block;
}
.company_logo {
    height: 56px;
    max-width: 200px;
}
.platform_name {
    padding-bottom: 30px;
    font-size: 22px;
    color: #0b3d2e;
    font-weight: 600;
    text-align: center;
    letter-spacing: 1px;
}
.login_form :deep(.el-input__wrapper) {
    padding: 0 12px !important;
    background-color: #fff !important;
    width: 100%;
    border-radius: 6px;
    box-shadow: 0 0 0 1px #e5e7eb inset !important;
    height: 42px;
}
.login_form :deep(.el-input__wrapper:hover) {
    box-shadow: 0 0 0 1px #0b3d2e inset !important;
}
.login_form :deep(.el-input__wrapper.is-focus) {
    box-shadow: 0 0 0 1px #0b3d2e inset !important;
}
:deep(.el-input__inner) {
    height: 40px !important;
    font-size: 14px;
    color: #333;
}
:deep(.el-input__inner::placeholder) {
    color: #9ca3af;
}
:deep(.el-input__prefix-inner) {
    color: #6b7280;
    font-size: 16px;
}
.item_container {
    margin-bottom: 18px;
}
.captcha_wrap {
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.captcha_img {
    width: 110px;
    height: 42px;
    border-radius: 6px;
    cursor: pointer;
    border: 1px solid #e5e7eb;
}
.login_button {
    width: 100%;
    padding: 0 16px;
    height: 42px;
    margin-top: 10px;
    margin-bottom: 12px;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
    line-height: 42px;
    background: #0b3d2e !important;
    border-radius: 6px;
    border: none;
    letter-spacing: 4px;
}
.login_button:hover {
    background-color: #082d22 !important;
}
.login_button:active {
    background-color: #06231a !important;
}
.beian-bar {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 9999;

    display: flex;
    align-items: center;
    justify-content: center;
    flex-wrap: wrap;

    padding: 10px 16px;
    background: transparent;
    line-height: 1.6;
}

.beian-item,
.beian-link,
.beian-gongan {
    font-size: 14px;
    color: rgba(255, 255, 255, 0.85);
}

.beian-divider {
    color: rgba(255, 255, 255, 0.5);
    margin: 0 10px;
    font-size: 14px;
}

.beian-link {
    color: rgba(255, 255, 255, 0.85) !important;
}
.beian-link:hover {
    color: #ffffff !important;
}

.gongan-icon {
    width: 16px;
    height: 17px;
    vertical-align: middle;
    margin-right: 4px;
}

.beian-gongan {
    display: inline-flex;
    align-items: center;
}

body {
    padding-bottom: 44px;
}
</style>
